module.exports = __webpack_public_path__ + "img/avatar.d66c8dc3.jpg";